import React, { useState, useEffect, useContext } from 'react'
import {
    Box, Button, Dialog, DialogContent,
    Popover, Typography, Avatar, TextField, IconButton, Divider, InputAdornment, FormControlLabel, Radio, RadioGroup, ListItemIcon, Checkbox
} from "@mui/material";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import SearchIcon from '@mui/icons-material/Search';
// import frame from "../../../../../Assets/img/upload-image.png";
import { ReactComponent as Nonverified } from "../../../../../Assets/img/icons/Non-verified-icon.svg";
import { ReactComponent as Verified } from "../../../../../Assets/img/icons/Verified-icon-new.svg";
import { ReactComponent as Filter } from "../../../../../Assets/img/icons/filter-icon.svg";
import { ContactsDetContext } from '../../../../ContactsDetContext';
import useApi from '../../../../Utilities/useAPI';
import { ReactComponent as Neoin } from "../../../../../Assets/img/icons/Neoin.svg";
import { useParams } from 'react-router-dom';
import { useUserDetailContext } from '../../../../UserDetailContext';
import { useQuantityContext } from '../../../../QuantityContext';
import { getPersonalProfileFamilyReducer } from '../../../../../Redux/Reducers/ProfileReducer';
import { useDispatch } from 'react-redux';
import { getFamilyCardReducer } from '../../../../../Redux/Reducers/CardReducer';

const AddContactMembers = ({ contactOpen, handleContactClose, relationSelected }) => {

    const { userDetails, setUserDetails } = useUserDetailContext();
    const contactFilters = [
        { key: 'neoinContacts', label: 'Neoin Contacts', icon: <Neoin width={24} height={24} /> },
        { key: 'verifiedContacts', label: 'Verified Contacts', icon: <Verified width={24} height={24} /> },
        { key: 'unverifiedContacts', label: 'Unverified Contacts', icon: <Nonverified width={24} height={24} /> }
    ];
    const { id } = useParams();
    const { openSnackbar } = useQuantityContext();
    const { callApiFunction } = useApi();
    // const { ConnectedContacts } = useContext(ContactsDetContext);
    const [ConnectedContacts, setConnectedContacts] = useState([]);
    const [unVerifiedCount, setUnVerifedCount] = useState([]);
    const [UnverifiedContacts, setUnverifiedContacts] = useState([]);
    const [favouriteContacts, setFavoriteContacts] = useState([]);

    const dispatch = useDispatch();
    const [searchQuery, setSearchQuery] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedContact, setSelectedContact] = useState(null); // For single contact selection
    const [filteredContacts, setFilteredContacts] = useState(ConnectedContacts);

    const [selectedFilters, setSelectedFilters] = useState({
        verifiedContacts: false,
        unverifiedContacts: false,
    });

    // Handle search input
    const handleInputChange = (event) => {
        setSearchQuery(event.target.value);
    };

    // Handle filter button click
    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // Handle filter checkbox change
    const handleFilterChange = (filter) => {
        setSelectedFilters(prevFilters => ({
            ...prevFilters,
            [filter]: !prevFilters[filter]
        }));
    };

    // Filter contacts based on search and filters
    const filterContacts = (query) => {
        const lowerCaseQuery = query.toLowerCase(); // Case insensitive search
        const results = ConnectedContacts.filter(member => {
            // Full name and neoin_id matching
            const fullName = `${member.name}`.toLowerCase();
            const matchesQuery = fullName.includes(lowerCaseQuery) || member.neoin_id.toLowerCase().includes(lowerCaseQuery);

            // If both Verified and Unverified filters are checked, skip filter logic
            const skipVerificationFilter = selectedFilters.verifiedContacts && selectedFilters.unverifiedContacts;

            // Apply verified/unverified filters only if both are not selected
            const isVerified = skipVerificationFilter ? true : selectedFilters.verifiedContacts ? member.verified : true;
            const isUnverified = skipVerificationFilter ? true : selectedFilters.unverifiedContacts ? !member.verified : true;

            // Combine search match and filter conditions
            return matchesQuery && isVerified && isUnverified;
        });

        // Remove duplicates by contact_ref_id
        const uniqueResults = Array.from(new Set(results.map(member => member.contact_ref_id)))
            .map(id => results.find(member => member.contact_ref_id === id));

        // Limit results to at most 20 members
        setFilteredContacts(uniqueResults.slice(0, 20)); // Only show top 20
    };


    useEffect(() => {
        const fetchContacts = async () => {

            try {
                const response = await callApiFunction('ConnectedContacts');

                const data = response;
                if (data.statusCode === 200) {
                    const members = data.data.map(member => {
                        // Logic for role and subTitle
                        const role = member.designation || member.field_of_study || member.title || '---';  // Updated role logic
                        const subTitle = member.profession_department || member.institute || member.nickname || '---';  // New subTitle logic

                        return {
                            id: member.id,
                            contact_ref_id: member.contact_ref_id,
                            img: member.profile_url,  // Fallback to default image if profile URL is null
                            is_favourite: member?.is_favourite ? true : false,
                            name: `${member.first_name} ${member.last_name}`,
                            role: role,  // Based on new logic
                            email: `${member.first_name.toLowerCase()}.${member.last_name.toLowerCase()}@example.com`,  // Mock email as it's not provided
                            verified: member.is_verified ? true : false,
                            neoin_id: member.unique_id,
                            subTitle: subTitle  // Add new subTitle field
                        };
                    });
                    setConnectedContacts(members)

                    const unverifiedMembers = members.filter(member => !member.verified);
                    setUnverifiedContacts(unverifiedMembers);
                    setUnVerifedCount(unverifiedMembers.length);

                    // Filter and set favorite contacts
                    const favoriteMembers = members.filter(member => member.is_favourite);
                    setFavoriteContacts(favoriteMembers);
                }
            } catch (err) {
                console.log('An error occurred while sending the connection request:', err);
            }
        }
        fetchContacts();
    }, [])




    // Debounced search input handling
    useEffect(() => {
        const debounceSearch = setTimeout(() => {
            filterContacts(searchQuery);
        }, 300);

        return () => clearTimeout(debounceSearch);
    }, [searchQuery, contactFilters]);

    const handleRadioChange = (contactId) => {
        setSelectedContact(contactId);
    };

    // Handle Invite button click
    const handleInvite = async () => {
        if (!selectedContact) return;
        // Dont change this into === , Check properly if u Change
        const selectedMember = filteredContacts.find(member => member.neoin_id == selectedContact);
        const payload = {
            groupId: id,
            isVerified: selectedMember.verified,
            role: "MEMBER",
            group_category: "Family",
            relationship: relationSelected,
            memberName: selectedMember.name,
            userRefId: selectedMember.contact_ref_id,
            requester_firstName: userDetails.firstName,
            requester_lastName: userDetails.lastName,
            requester_profileUrl: userDetails.proFile || ''
        };
        let response;

        try {
            const response = await callApiFunction('addMemberFromContact', payload);

            if (response.statusCode === 202) {
                openSnackbar("Member already Invited", "info");
                handleContactClose();
            } else if (response.status === "SUCCESS") {
                await dispatch(getPersonalProfileFamilyReducer());
                // const payload = { id: id };
                await dispatch(getFamilyCardReducer(id))
                openSnackbar("Member Invited Successfull", "success");
                handleContactClose();
            } else {
                openSnackbar("Something went Wrong!", "error");
            }
        } catch (error) {
            console.log("API ERROR", error);
            openSnackbar("Something went Wrong!", "error");
        }
    };

    return (
        <>
            <Dialog open={contactOpen} onClose={handleContactClose}>
                <Box style={{ minWidth: "550px" }}>
                    <div className='flex-center-between px-4 pt-4'>
                        <div>Add Members from Contact List</div>
                        <div onClick={handleContactClose}>
                            <IconButton className="m-0 p-0">
                                <CloseRoundedIcon />
                            </IconButton>
                        </div>
                    </div>

                    <div className='mt-0 mb-3 group_permissiions_options px-4'>Invite a member to join your family group</div>

                    <div className='d-flex align-items-center justify-content-between px-4 my-3'>
                        <TextField style={{ width: "70%" }}
                            placeholder="Search by ID or name"
                            variant="outlined"
                            size="small"
                            className="me-2"
                            value={searchQuery}
                            onChange={handleInputChange}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <div className="icon-svg-24 flex-center ml-0">
                                            <SearchIcon className="icon-color" />
                                        </div>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <div className='flex-center gap-4'>
                            <IconButton onClick={handleFilterClick}>
                                <Filter />
                            </IconButton>
                        </div>
                    </div>

                    <Popover
                        id={Boolean(anchorEl) ? 'filter-popover' : ''}
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                    >
                        <Box p={2} sx={{ width: '300px', borderRadius: '8px', backgroundColor: '#fff' }}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                <Typography variant="body" sx={{ fontWeight: 'bold' }}>
                                    Filter by
                                </Typography>
                                <IconButton onClick={handleClose} size="small">
                                    <CloseRoundedIcon />
                                </IconButton>
                            </Box>
                            <Divider sx={{ marginBottom: 2 }} />
                            {contactFilters.map(({ key, label, icon }) => (
                                <div className="flex-center-between" key={key}>
                                    <div className="d-flex align-items-center">
                                        <ListItemIcon>{icon}</ListItemIcon>
                                        <Typography variant="body1">{label}</Typography>
                                    </div>
                                    <Checkbox
                                        checked={selectedFilters[key]}
                                        onChange={() => handleFilterChange(key)}
                                    />
                                </div>
                            ))}
                        </Box>
                    </Popover>

                    <DialogContent className='m-0 p-0' style={{ scrollbarWidth: "thin", maxHeight: "350px", overflowY: "auto" }}>
                        <RadioGroup value={selectedContact} onChange={(e) => handleRadioChange(e.target.value)}>
                            {filteredContacts.map((member) => (
                                <div className='p-3 group_card_adding_memb w-100'>
                                    <div className='person_details flex-center-between'>
                                        <div className='profile_name_details d-flex align-items-center gap-2'>
                                            <div style={{ width: "40px", height: "40px", position: "relative" }}>
                                                <div className="avatar-image t" style={{ width: "40px", height: "40px" }}>
                                                    <Avatar src={member.img} alt={member.name}>{member.name.charAt(0)}</Avatar>
                                                </div>
                                                <div className={`flex-center icon-16px`} style={{ position: "absolute", right: 0, bottom: 0, backgroundColor: "#fff", borderRadius: "50%" }}>
                                                    {member.verified ?
                                                        <Verified style={{ color: "#43A047" }} /> :
                                                        <Nonverified />
                                                    }
                                                </div>
                                            </div>
                                            <div className='d-flex flex-column'>
                                                <div>{member.name}</div>
                                                <div>{member.neoin_id}</div>
                                            </div>
                                        </div>
                                        <Radio value={member.neoin_id} />
                                    </div>
                                </div>
                            ))}
                        </RadioGroup>
                    </DialogContent>

                    <div style={{ borderTop: "1px solid rgba(0, 0, 0, 0.18)" }}></div>
                    {/* <DialogActions> */}
                    <div className='d-flex align-items-center justify-content-end gap-3 my-4 mx-4'>
                        <Button onClick={handleContactClose} className='color-blue'>Cancel</Button>
                        <Button variant='contained' sx={{ backgroundColor: "#0044C6" }} onClick={handleInvite} disabled={!selectedContact} >INVITE</Button>
                    </div>
                    {/* </DialogActions> */}
                </Box>
            </Dialog >
        </>
    )
}

export default AddContactMembers;
